import { Flex, FormControl, Input } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { TexasFormLabel } from '@texas/components/shared/form/TexasFormLabel';
import { TexasInputWrapper } from '@texas/components/shared/TexasInputWrapper';
import { SelectColor } from './SelectColor';
import { forwardRef, useImperativeHandle, useState } from 'react';

export interface GenericWidgetSettingsHandle {
  getValues(): { name: string; color: string | null };
}

interface GenericWidgetSettingsProps {
  initialName: string;
  initialColor: string | null;
  namePlaceholder?: string;
}

export const GenericWidgetSettings = forwardRef<
  GenericWidgetSettingsHandle,
  GenericWidgetSettingsProps
>(function GenericWidgetSettings(
  { initialName, initialColor, namePlaceholder },
  ref,
) {
  const { t } = useTranslation();
  const [name, setName] = useState(initialName);
  const [color, setColor] = useState<string | null>(initialColor);

  useImperativeHandle(ref, () => ({
    getValues: () => ({ name, color }),
  }));

  return (
    <Flex gap={4}>
      <TexasInputWrapper label={t('widgets.name')}>
        <Input
          value={name}
          placeholder={namePlaceholder ?? t('widgets.name')}
          onChange={(e) => setName(e.target.value)}
        />
      </TexasInputWrapper>
      <FormControl>
        <TexasFormLabel pb={1}>{t('widgets.selectColor')}</TexasFormLabel>
        <SelectColor selectedColor={color} onChange={setColor} />
      </FormControl>
    </Flex>
  );
});
